export default __webpack_public_path__ + "static/media/778.e9ed5af3.png";